import { ReactNode, createContext, useCallback, useContext } from 'react'
import { OpenAPIDocument, useOpenAPIDocumentOpenAPI } from '../documents/OpenAPIDocument'
import { Change } from './changes/Change'

export type Dispatch<T> = (value: T) => void

const DispatchChangeContext = createContext<Dispatch<Change> | null>(null)

export function useDispatchChange() {
  const dispatchChange = useContext(DispatchChangeContext)
  if (!dispatchChange) {
    throw new Error(`useDispatchChange() must be called within a <DispatchChangeProvider /> component.`)
  }
  return dispatchChange
}

export function DispatchChangeProvider({ document, children }: { document: OpenAPIDocument; children?: ReactNode }) {
  const openAPI = useOpenAPIDocumentOpenAPI(document)

  const dispatchChange = useCallback(
    (change: Change) => {
      if (!openAPI) {
        throw new Error('Cannot update OpenAPI document before it is loaded')
      }
      const changedOpenAPI = structuredClone(openAPI)
      change.apply(changedOpenAPI)
      document.updateOpenAPI(changedOpenAPI)
    },
    [document, openAPI]
  )
  return <DispatchChangeContext.Provider value={dispatchChange}>{children}</DispatchChangeContext.Provider>
}
